export const SET_PAGINATION_REGISTER_ORGAN = 'SET_PAGINATION_REGISTER_ORGAN';

export const setPaginationRegisterOrgan = payload => ({
  type: SET_PAGINATION_REGISTER_ORGAN,
  payload,
});
